import React from 'react';
import { useTranslation } from 'react-i18next';
import { capitalize } from 'helpers/helpers';
import ModalForm from 'components/Form/ModalForm';
import {
    WidgetContent,
    WidgetT,
} from 'routes/Dashboard/components/WidgetsLayout/helpers';

type Props = {
    widget: WidgetT;
    isEditModalOpen: boolean;
    setIsEditModalOpen: (arg1: boolean) => void;
    value: string;
    onEditWidget: (arg1: { widget: WidgetT; content: WidgetContent }) => void;
};

export default function EditModal({
    widget,
    isEditModalOpen,
    setIsEditModalOpen,
    value,
    onEditWidget,
}: Props): React.ReactElement {
    const { t } = useTranslation();
    return (
        <ModalForm
            show={isEditModalOpen}
            fullWidth
            closeModal={() => setIsEditModalOpen(false)}
            submit={({ text }: { text: string }) => {
                onEditWidget({
                    widget,
                    content: { text },
                });
                setIsEditModalOpen(false);
            }}
            submitText={capitalize(t(`widget.update`))}
            title=""
            fields={[
                {
                    key: 'text',
                    name: 'title',
                    label: capitalize(t(`widget.text`)),
                    type: 'text',
                    value,
                    validators: ['required'],
                },
            ]}
        />
    );
}
